import styled from "styled-components";

export const VideoContainer = styled.div.attrs({
  className: "embed-responsive embed-responsive-16by9 mx-auto"
})`
  ${({ theme }) => theme.sm`
      width: 75%;
   `}
`;
